import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { DashboardState } from "../models/DashboardState";

const setPageClients = (state: DashboardState, action: PayloadAction<Page>) => {
    state.clientsPage.page = action.payload.page;
}

export default setPageClients;